import { render, staticRenderFns } from "./AppAPay.vue?vue&type=template&id=623d1456&"
import script from "./AppAPay.vue?vue&type=script&lang=js&"
export * from "./AppAPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports